import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { preferenciasNotificacaoService } from "@/core/services/preferenciasNotificacaoService";
import { useAuth } from "@/core/hooks/useAuth";

const preferenciasKey = (pessoaId: string) => ["preferencias-notificacao", pessoaId];

/** Preferências de notificação por categoria da pessoa logada (canal "push"). */
export function useMinhasPreferenciasNotificacao() {
  const { pessoa } = useAuth();
  return useQuery({
    queryKey: preferenciasKey(pessoa?.id ?? ""),
    queryFn: () => preferenciasNotificacaoService.listarDaPessoa(pessoa!.id),
    enabled: !!pessoa,
  });
}

export function useDefinirPreferenciaNotificacao() {
  const queryClient = useQueryClient();
  const { pessoa } = useAuth();
  return useMutation({
    mutationFn: (input: { categoria: string; ativo: boolean }) =>
      preferenciasNotificacaoService.definirPreferencia(pessoa!.id, input.categoria, input.ativo),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: preferenciasKey(pessoa?.id ?? "") }),
  });
}
